import React, { useContext, useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import VariableContext from "../contexts/VariableContext";
import FetchingFreq from "../contexts/FetchingFreq";
import apiService from "../services/apiService";
import { useToast } from "../contexts/ToastContext";
import { useConfirm } from "../contexts/ConfirmContext";
import OpenProperties from "./OpenProperties";
import MyChartComponent from "./MyChartComponent";
import FrequencyTableComponent from "./FrequencyTableComponent";
import HoverDropdown from "./HoverDropdown";
import MultiResponse from "./MultiResponse";
import DataGrid from "./DataGrid";
import MultiDataGrid from "./MultiDataGrid";
import Grid3DData from "./Grid3DData";
import CrosstabTable from "./CrosstabTable";
import CustomizedVariable from "./CustomizedVariable";
import PropertiesComponent from "./PropertiesComponent";

import * as XLSX from "xlsx";
import { useAuth } from "../providers/AuthProvider";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./styles/DataTables.css";

import {
  faFolder,
  faFile,
  faTable,
  faChartBar,
  faArrowLeft,
  faGear,
  faDownload,
  faGauge,
  faBuilding,
  faWeightScale,
  faPeopleRoof,
  faHouse,
  faLaptopFile,
  faChargingStation,
  faUpload,
  faPlus,
  faGlobe,
  faFileExport,
  faArrowsLeftRight,
  faRefresh,
  faRobot,
  faTimes,
  faCheckCircle,
  faSpinner,
  faTrash,
  faFileExcel,
  faFileAlt,
  faPaperPlane,
  faComments,
  faSave,
} from "@fortawesome/free-solid-svg-icons";
import Loader from "./Loader";
import RunTableSettingsModal from "./RunTableSettingsModal";

function DataTables() {
  const {
    dataGroup,
    setdataGroup,
    selectedVariables,
    banners,
    setBanners,
    setSelectedVariables,
    projectId,
    savedWeightings,
    saveCurrentWeighting,
    currentSelectedVariablesset,
    setcurrentSelectedVariablesset,
    setSavedWeightings,
    weightingStats,
    setWeightingStats,
    
    currentSelectedVariables,
    setCurrentSelectedVariables,
    setSelectedClient,
    selectedProject,
    selectedClient,
    powner,
    selectedProjectDetails,setSdataGroup
  } = useContext(VariableContext);

  const {
    setMessage,
    setActivePage,
    handleTitleClick,
    selectedTitle,
    setSelectedTitle,
    refreshData,
    setRefreshData,
    selectedBanner,
    setselectedBanner,
    selectedWeights,
    setSelectedWeights,
    selectedVariable,
    setSelectedVariable,
    loading,
    setLoading, isPropertiesShow, setIsPropertiesShow, nets, setNets,
    frequencyData
  } = useContext(FetchingFreq);

  const { user } = useAuth();
  const { toast } = useToast();
  const { confirm } = useConfirm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAModalOpen, setIsaModalOpen] = useState(false);
  const [isbilendi, setBilendi] = useState(false);
  const [bilendiSeparateSheet, setBilendiSeparateSheet] = useState(false);
  const [saveBanner, setSaveBanner] = useState(false);

  const [jsonScript, setJsonScript] = useState(false);

  // ── Shared import file ref ────────────────────────────────────────────────
  const sharedFileRef = useRef(null);
  const [sharedFile, setSharedFile] = useState(null);
  const [sharedFileAccept, setSharedFileAccept] = useState("*");

  const openSharedPicker = (accept) => {
    setSharedFileAccept(accept);
    // small timeout so accept attr updates before click
    setTimeout(() => { if (sharedFileRef.current) { sharedFileRef.current.accept = accept; sharedFileRef.current.value = ""; sharedFileRef.current.click(); } }, 10);
  };

  const onSharedFileChange = (e) => {
    const file = e.target.files[0] || null;
    setSharedFile(file);
  };

  // Dispatch to Tab Specs modal (Excel)
  const dispatchTabSpecs = () => {

    toggleTabSpecsModal();
  };

  // ── Helper: read sharedFile as parsed JSON ───────────────────────────────
  const readSharedFileAsJson = () =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        try { resolve(JSON.parse(e.target.result)); }
        catch (err) { reject(new Error("Invalid JSON file: " + err.message)); }
      };
      reader.onerror = () => reject(new Error("Failed to read file"));
      reader.readAsText(sharedFile);
    });

  // Dispatch to Table JSON → uploads to sdatagroup_json, then updates dataGroup in UI
  const dispatchTableJson = async () => {
    if (!sharedFile) return;
    try {
      setLoading(true);
      // Parse file client-side first so we can update UI immediately
      const parsed = await readSharedFileAsJson();
      // Upload to server
      const formData = new FormData();
      formData.append("file", sharedFile);
      const response = await fetch(
        `${apiService.baseURL}/api/upload-qgroup-json/${projectId}`,
        { method: "POST", body: formData }
      );
      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.error || "Upload failed");
      }
      setdataGroup(parsed);
      toast.success("Table JSON uploaded and UI updated successfully");
    } catch (err) {
      toast.error(err.message || "Failed to upload Table JSON");
    } finally {
      setLoading(false);
    }
  };

  // Dispatch to Banner JSON → uploads to banner endpoint, then updates banners in UI
  const dispatchBannerJson = async () => {
    if (!sharedFile) return;
    try {
      setLoading(true);
      const parsed = await readSharedFileAsJson();
      if (!Array.isArray(parsed)) {
        toast.warning("Banner JSON must be an array");
        return;
      }
      const formData = new FormData();
      formData.append("file", sharedFile);
      const response = await fetch(
        `${apiService.baseURL}/api/upload-banner-json/${projectId}`,
        { method: "POST", body: formData }
      );
      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.error || "Upload failed");
      }
      setBanners(parsed);
      toast.success("Banner JSON uploaded and UI updated successfully");
    } catch (err) {
      toast.error(err.message || "Failed to upload Banner JSON");
    } finally {
      setLoading(false);
    }
  };

  // Dispatch to Scripting → uploads to qgroup_json, then updates dataGroup in UI
  const dispatchScriptingJson = async () => {
    if (!sharedFile) return;
    try {
      setLoading(true);
      const parsed = await readSharedFileAsJson();
      const formData = new FormData();
      formData.append("file", sharedFile);
      const response = await fetch(
        `${apiService.baseURL}/api/upload-sdatagroup-json/${projectId}`,
        { method: "POST", body: formData }
      );
      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.error || "Upload failed");
      }
      setSdataGroup(parsed);
      toast.success("Scripting JSON uploaded and UI updated successfully");
    } catch (err) {
      toast.error(err.message || "Failed to upload Scripting JSON");
    } finally {
      setLoading(false);
    }
  };

  const handleUploadQgroupJson = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    try {
      setLoading(true);
      // Parse client-side to update UI immediately on success
      const text = await file.text();
      const parsed = JSON.parse(text);
      const formData = new FormData();
      formData.append("file", file);
      const response = await fetch(
        `${apiService.baseURL}/api/upload-qgroup-json/${projectId}`,
        { method: "POST", body: formData }
      );
      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.error || "Upload failed");
      }
      setdataGroup(parsed);
      toast.success("JSON uploaded and UI updated successfully");
    } catch (err) {
      toast.error(err.message || "Failed to upload JSON");
    } finally {
      setLoading(false);
      e.target.value = "";
    }
  };

  const [exportType, setExportType] = useState("both");
  const [sigText, setsigText] = useState(false);
  const [runTablesLoading, setRunTablesLoading] = useState(false);
  const [runTablesStatus, setRunTablesStatus] = useState("idle"); // idle | running | done | error
  const [runTablesSigTest, setRunTablesSigTest] = useState(false);
  const [runTablesLayout, setRunTablesLayout] = useState("rows"); // rows | cols
  const [runTablesSurvation, setRunTablesSurvation] = useState(false);
  // ── Master table settings (single object — add new keys here as features grow) ──
  const DEFAULT_TABLE_SETTINGS = {
    freqDecimals: 0, pctDecimals: 1, baseDecimals: 0,
    meanDecimals: 2, medianDecimals: 2, stdDecimals: 2, seDecimals: 2,
    modeDecimals: 2, minDecimals: 2, maxDecimals: 2, q1Decimals: 2, q3Decimals: 2,
    cellFreqDecimals: 4, cellPctDecimals: 4, cellBaseDecimals: 0,
    showUnweightedBase: true, showWeightedBase: true, showBasePct: false,
    globalFilter: '',
    separateExcelPerFilter: false,
    separateExcelPerOutput: false,
    showTotalEachGroup: false,
  };
  const [tableSettings, setTableSettings] = useState(DEFAULT_TABLE_SETTINGS);
  const [outputSets, setOutputSets] = useState([]);
  const [settingsModalOpen, setSettingsModalOpen] = useState(false);
  const [exportOptions, setExportOptions] = useState([
    { text: "Export Percentages", value: "percent" },
    { text: "Export Frequencies", value: "frequency" },
    { text: "Export Both", value: "both" },
  ]);
  const allExportTypes = [
    { type: "Uncle", text: "Uncle Tables", feature: "uncle" },
    { type: "Quantum", text: "Quantum Tables", feature: "quantum" },
    { type: "Wincross", text: "Wincross Tables", feature: "wincross" },
  ];
  const [exportfeatures, setExportfeatures] = useState([]);
  const [crosstabDisplayData, setCrosstabDisplayData] = useState(null);
  const [activeTab, setActiveTab] = useState(
    banners && banners.length > 0 ? banners[0]?.name || "" : ""
  );
  const [displayMode, setDisplayMode] = useState("table");
  const [isCrossTab, setisCrossTab] = useState(false);
  const [exportOption, setExportOption] = useState(false);
  const [fileName, setFileName] = useState("");
  const [displaySettings, setDisplaySettings] = useState({
    showFrequency: true,
    showPercent: true,
  });

  // Merged display settings passed to all table components
  const fullDisplaySettings = {
    ...displaySettings,
    ...tableSettings,
  };
  const [isControlPanelOpen, setIsControlPanelOpen] = useState(false);
  const [allowedExports, setAllowedExports] = useState([]);
  const [hasLanded, setHasLanded] = useState(false);
  const [isTabSpecsModalOpen, setIsTabSpecsModalOpen] = useState(false);

  // ── Tab Specs uploader state ──────────────────────────────────────────────
  const [tabSpecFile, setTabSpecFile] = useState(null);
  const [questionnaireFile, setQuestionnaireFile] = useState(null);
  const [status, setStatus] = useState("idle"); // idle | processing | success | error
  const [statusMessage, setStatusMessage] = useState("");
  const [progress, setProgress] = useState(0);
  const tabSpecInputRef = useRef(null);
  const questionnaireInputRef = useRef(null);

  // ── Chat state ────────────────────────────────────────────────────────────
  const [chatMessages, setChatMessages] = useState([]);
  // each entry: { role: "user" | "assistant", text: string, isStreaming?: boolean }
  const [chatHistory, setChatHistory] = useState([]);
  // Gemini history array { role, parts } — passed back each turn
  const [chatInput, setChatInput] = useState("");
  const [chatBusy, setChatBusy] = useState(false);
  const chatBodyRef = useRef(null);
  const chatInputRef2 = useRef(null);

  // ── Save-to-DB state ──────────────────────────────────────────────────────
  const [saveStatus, setSaveStatus] = useState("idle"); // idle | saving | saved | error
  const [saveError, setSaveError]   = useState("");
  // Retain file text so chat can re-reference tabspec & questionnaire
  const [tabSpecText, setTabSpecText] = useState("");
  const [questionnaireText, setQuestionnaireText] = useState("");

  // ── Toggle modal (reset everything on close) ──────────────────────────────
  const toggleTabSpecsModal = () => {
    setIsTabSpecsModalOpen((prev) => !prev);
    if (!isTabSpecsModalOpen) {
      setTabSpecFile(null);
      setQuestionnaireFile(null);
      setStatus("idle");
      setStatusMessage("");
      setProgress(0);
      setChatMessages([]);
      setChatHistory([]);
      setChatInput("");
      setTabSpecText("");
      setQuestionnaireText("");
      if (tabSpecInputRef.current) tabSpecInputRef.current.value = "";
      if (questionnaireInputRef.current) questionnaireInputRef.current.value = "";
    }
  };

  // ── File helpers ──────────────────────────────────────────────────────────
  const formatFileSize = (bytes) => {
    if (!bytes) return "";
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  };

  const handleTabSpecChange = (e) => setTabSpecFile(e.target.files[0] || null);
  const handleQuestionnaireChange = (e) => setQuestionnaireFile(e.target.files[0] || null);
  const makeDropHandler = (setter) => (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) setter(file);
  };
  const preventDefaults = (e) => e.preventDefault();

  // ── Initial AI processing ─────────────────────────────────────────────────
  const handleProcess = async () => {
    if (!tabSpecFile || !questionnaireFile) {
      setStatus("error");
      setStatusMessage("Please upload both files before processing.");
      return;
    }

    setStatus("processing");
    setStatusMessage("Preparing survey data and sending to AI backend…");
    setProgress(10);

    // Read both files as text client-side so chat can reuse them without
    // re-uploading. Plain-text files (csv, json) decode directly; binary
    // formats (xlsx, docx) are sent as-is and the backend converts them,
    // so we store the raw base64 for those and let the backend decode again.
    const readAsText = (file) =>
      new Promise((resolve) => {
        const ext = file.name.split(".").pop().toLowerCase();
        if (["csv", "json", "txt"].includes(ext)) {
          const r = new FileReader();
          r.onload = (e) => resolve(e.target.result);
          r.readAsText(file, "utf-8");
        } else {
          // For xlsx / xls / docx — send filename only; backend already has
          // the converted text from the initial call. We'll pass the filename
          // so the backend context message is descriptive.
          resolve(`[binary file: ${file.name}]`);
        }
      });

    const [tsText, qText] = await Promise.all([
      readAsText(tabSpecFile),
      readAsText(questionnaireFile),
    ]);
    setTabSpecText(tsText);
    setQuestionnaireText(qText);

    const jsonBlob = new Blob([JSON.stringify(dataGroup)], { type: "application/json" });
    const formData = new FormData();
    formData.append("json_file", jsonBlob, `survey_data_${projectId || "project"}.json`);
    formData.append("tabspec_file", tabSpecFile);
    formData.append("questionnaire_file", questionnaireFile);

    const progressInterval = setInterval(() => {
      setProgress((p) => Math.min(p + 5, 85));
    }, 1500);

    try {
      const response = await fetch(`${apiService.baseURL}/api/process-tabspecs/${projectId}`, {
        method: "POST",
        body: formData,
      });

      clearInterval(progressInterval);
      setProgress(90);

      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.error || `Server error: ${response.status}`);
      }

      const result = await response.json();
      setProgress(100);

      if (result.updatedJson) setdataGroup(result.updatedJson);
      if (result.banners && Array.isArray(result.banners)) setBanners(result.banners);

      setStatus("success");
      setStatusMessage("JSON updated successfully! Banners have been applied to your project.");
      if (setMessage) toast.success("Tab specs processed successfully!");

      // Reset chat for this fresh result
      setChatMessages([]);
      setChatHistory([]);
    } catch (err) {
      clearInterval(progressInterval);
      setProgress(0);
      setStatus("error");
      setStatusMessage(err.message || "An unexpected error occurred.");
    }
  };

  // ── Save current JSON & banners to the database ──────────────────────────
  const handleSaveToDb = async () => {
    if (!projectId) {
      setSaveError("No project selected.");
      setSaveStatus("error");
      return;
    }
    setSaveStatus("saving");
    setSaveError("");
    try {
      const response = await fetch(
        `${apiService.baseURL}/api/save-tabspecs/${projectId}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updatedJson: dataGroup, banners }),
        }
      );
      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.error || `Server error: ${response.status}`);
      }
      setSaveStatus("saved");
      if (setMessage) toast.success("Tab specs saved to database successfully!");
      // Auto-reset the button label after 3 s
      setTimeout(() => setSaveStatus("idle"), 3000);
    } catch (err) {
      setSaveError(err.message || "Save failed.");
      setSaveStatus("error");
      setTimeout(() => setSaveStatus("idle"), 4000);
    }
  };

  // ── Reset uploader ────────────────────────────────────────────────────────
  const handleReset = () => {
    setTabSpecFile(null);
    setQuestionnaireFile(null);
    setStatus("idle");
    setStatusMessage("");
    setProgress(0);
    setChatMessages([]);
    setChatHistory([]);
    setChatInput("");
    setTabSpecText("");
    setQuestionnaireText("");
    if (tabSpecInputRef.current) tabSpecInputRef.current.value = "";
    if (questionnaireInputRef.current) questionnaireInputRef.current.value = "";
  };

  // ── Chat: send one turn via SSE streaming ─────────────────────────────────
  const handleChatSend = async () => {
    const text = chatInput.trim();
    if (!text || chatBusy) return;

    setChatInput("");
    setChatBusy(true);

    // Append user bubble immediately
    setChatMessages((prev) => [...prev, { role: "user", text }]);
    // Placeholder streaming bubble
    setChatMessages((prev) => [...prev, { role: "assistant", text: "", isStreaming: true }]);

    let fullText = "";

    try {
      const res = await fetch(
        `${apiService.baseURL}/api/stream-chat-tabspecs/${projectId}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            message:           text,
            history:           chatHistory,
            currentJson:       dataGroup,
            banners:           banners,
            tabSpecText:       tabSpecText,
            questionnaireText: questionnaireText,
          }),
        }
      );

      if (!res.ok) throw new Error(`Server error: ${res.status}`);

      const reader  = res.body.getReader();
      const decoder = new TextDecoder();
      let buffer    = "";

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        buffer += decoder.decode(value, { stream: true });
        const lines = buffer.split("\n");
        buffer = lines.pop(); // keep incomplete last line

        for (const line of lines) {
          if (!line.startsWith("data: ")) continue;
          try {
            const event = JSON.parse(line.slice(6));

            if (event.type === "token") {
              fullText += event.text;
              // Update the last (streaming) bubble in place
              setChatMessages((prev) => {
                const updated = [...prev];
                updated[updated.length - 1] = {
                  role: "assistant",
                  text: fullText,
                  isStreaming: true,
                };
                return updated;
              });
            }

            if (event.type === "done") {
              fullText = event.fullText || fullText;

              // Try to parse as a JSON edit response
              let clean = fullText.trim();
              if (clean.startsWith("```json")) clean = clean.slice(7);
              else if (clean.startsWith("```")) clean = clean.slice(3);
              if (clean.endsWith("```")) clean = clean.slice(0, clean.lastIndexOf("```")).trimEnd();

              let displayText = fullText;
              try {
                const parsed = JSON.parse(clean);
                if (parsed.updatedJson) {
                  setdataGroup(parsed.updatedJson);
                  if (parsed.banners && Array.isArray(parsed.banners)) setBanners(parsed.banners);
                  displayText = "✅ JSON updated successfully. The changes have been applied to your project.";
                }
              } catch (_) {
                // conversational reply — display as-is
              }

              // Finalise bubble
              setChatMessages((prev) => {
                const updated = [...prev];
                updated[updated.length - 1] = {
                  role: "assistant",
                  text: displayText,
                  isStreaming: false,
                };
                return updated;
              });

              // Accumulate Gemini history for next turn
              setChatHistory((prev) => [
                ...prev,
                { role: "user",  parts: [{ text }] },
                { role: "model", parts: [{ text: event.fullText || fullText }] },
              ]);
            }

            if (event.type === "error") {
              throw new Error(event.message);
            }
          } catch (_parseErr) {
            // malformed SSE line — skip
          }
        }
      }
    } catch (err) {
      setChatMessages((prev) => {
        const updated = [...prev];
        updated[updated.length - 1] = {
          role: "assistant",
          text: `⚠️ Error: ${err.message}`,
          isStreaming: false,
        };
        return updated;
      });
    } finally {
      setChatBusy(false);
    }
  };

  // Auto-scroll chat body to bottom on new messages
  useEffect(() => {
    if (chatBodyRef.current) {
      chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
    }
  }, [chatMessages]);

  // ── Other existing effects & handlers ─────────────────────────────────────
  useEffect(() => {
    setActivePage("tables");
  }, []);

  useEffect(() => {
    const organization = user?.user?.organization || user?.organization;
    if (organization) {
      if (
        organization.datatables_exports &&
        Array.isArray(organization.datatables_exports) &&
        organization.datatables_exports.length > 0
      ) {
        setAllowedExports(organization.datatables_exports);
        const filteredExports = allExportTypes.filter((exportType) =>
          organization.datatables_exports.includes(exportType.feature)
        );
        setExportfeatures(filteredExports);
      } else {
        console.warn("⚠️ No datatables_exports found, defaulting to all exports");
        setAllowedExports(allExportTypes.map((item) => item.feature));
        setExportfeatures(allExportTypes);
      }
    } else {
      console.warn("⚠️ No organization found, allowing all exports");
      setAllowedExports(allExportTypes.map((item) => item.feature));
      setExportfeatures(allExportTypes);
    }
  }, [user]);

  useEffect(() => {
    setHasLanded(false);
  }, [projectId]);

  // Auto-load output sets from the project DB when the project changes
  useEffect(() => {
    if (!projectId) { setOutputSets([]); return; }
    fetch(`${apiService.baseURL}/get_output_sets/${projectId}`)
      .then(r => r.ok ? r.json() : Promise.reject())
      .then(data => setOutputSets(data.outputSets || []))
      .catch(() => setOutputSets([]));
  }, [projectId]);

  const handleChangeOutputSets = (next) => {
    setOutputSets(next);
    if (!projectId) return;
    fetch(`${apiService.baseURL}/save_output_sets/${projectId}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ outputSets: next }),
    }).catch(() => {});
  };

  useEffect(() => {
    if (!hasLanded && selectedProjectDetails && selectedProjectDetails.has_database === false) {
      setIsPropertiesShow(true);
      setHasLanded(true);
    } else if (selectedProjectDetails) {
      setHasLanded(true);
    }
  }, [selectedProjectDetails, hasLanded, setIsPropertiesShow]);

  const scanAndUpdateVarNameLocations = async () => {
    const ok = await confirm({
      title: "Update VarName Locations",
      message: "Are you sure you want to update all varName locations? This action cannot be undone.",
      confirmText: "Update",
      variant: "danger",
    });
    if (!ok) return;
    setLoading(true);
    try {
      const updatedDataGroup = { ...dataGroup };
      let nextLocation = 11;
      let updatedCount = 0;
      let skippedCount = 0;

      const keys = Object.keys(updatedDataGroup);
      const sortedKeys = keys.sort((a, b) => {
        const orderA = updatedDataGroup[a]?.order || updatedDataGroup[a]?._order || 0;
        const orderB = updatedDataGroup[b]?.order || updatedDataGroup[b]?._order || 0;
        return orderA - orderB;
      });

      // console.log("Processing keys in order:", sortedKeys.map(key => ({
      //   key,
      //   order: updatedDataGroup[key]?.order || updatedDataGroup[key]?._order || 0
      // })));

      sortedKeys.forEach(key => {
        const variable = updatedDataGroup[key];
        if (variable && variable.varName && Array.isArray(variable.varName)) {
          const variableType = variable.type || "";
          const isStringType = variableType.toLowerCase().includes("string");
          const isStringGrid = variableType.toLowerCase().includes("stringgrid");

          if (isStringType || isStringGrid) {
            console.log(`Skipping ${key} - ${variableType}`);
            skippedCount++;
            return;
          }
          if (variable.varName.length === 0) return;

          const updatedVarNames = variable.varName.map(varNameObj => {
            if (!varNameObj) return varNameObj;
            const currentLocation = varNameObj.Location || "";
            if (!varNameObj.Location || currentLocation.trim() === "") return varNameObj;

            let newLocation = "";
            if (currentLocation.includes(":")) {
              const parts = currentLocation.split(":");
              if (parts.length === 2) {
                const start = Number(parts[0]);
                const end = Number(parts[1]);
                if (!isNaN(start) && !isNaN(end) && start <= end) {
                  const width = end - start + 1;
                  const newEnd = nextLocation + width - 1;
                  newLocation = `${nextLocation}:${newEnd}`;
                  nextLocation = newEnd + 1;
                  updatedCount++;
                  console.log(`Order ${variable.order || variable._order || 0}: ${key} - ${varNameObj.Name || 'unnamed'} - ${currentLocation} -> ${newLocation}`);
                } else newLocation = currentLocation;
              } else newLocation = currentLocation;
            } else {
              const numLocation = Number(currentLocation);
              if (!isNaN(numLocation) && currentLocation.trim() !== "") {
                newLocation = nextLocation.toString();
                nextLocation += 1;
                updatedCount++;
                console.log(`Order ${variable.order || variable._order || 0}: ${key} - ${varNameObj.Name || 'unnamed'} - ${currentLocation} -> ${newLocation}`);
              } else newLocation = currentLocation;
            }
            return { ...varNameObj, Location: newLocation };
          });

          if (JSON.stringify(variable.varName) !== JSON.stringify(updatedVarNames)) {
            updatedDataGroup[key] = { ...variable, varName: updatedVarNames };
          }
        }
      });

      setdataGroup(updatedDataGroup);
      toast.success(`Updated ${updatedCount} varName locations. Skipped ${skippedCount} String/StringGrid types. Next location: ${nextLocation}`);
    } catch (error) {
      toast.error("Error updating locations. Please check console for details.");
    } finally {
      setLoading(false);
    }
  };

  const closeModalAndUpdateButtons = () => {
    setIsModalOpen(false);
    handleTitleClick(selectedTitle);
  };

  const handleShowProperties = () => {
    setIsPropertiesShow(!isPropertiesShow);
  };

  const handleDisplaySettingsChange = (e) => {
    setDisplaySettings({
      ...displaySettings,
      [e.target.name]: e.target.checked,
    });
  };

const handleFileUpload = (e) => {
  setLoading(true);
  const input = e.target;
  const file = input.files[0];

  if (!file) return;

  setFileName(file.name);

  const reader = new FileReader();

  reader.onload = (evt) => {
    
    try {
      const data = new Uint8Array(evt.target.result);

      const workbook = XLSX.read(data, { type: "array" });

      const summarySheet = XLSX.utils.sheet_to_json(
        workbook.Sheets["Summary"],
        { header: 1 }
      );

      const detailsSheet = XLSX.utils.sheet_to_json(
        workbook.Sheets["Details"],
        { header: 1 }
      );

      const newDataGroup = parseExcelToDataGroup(summarySheet, detailsSheet);

      setdataGroup(newDataGroup);

    } catch (error) {
      toast.error("Error processing file. Please check format.");
    } finally {
      // 🔥 IMPORTANT FIX (same as previous issue)
      input.value = null;
      setLoading(false);
    }
  };

  reader.onerror = (err) => {
    toast.error("Failed to read file.");

    // 🔥 Reset here as well
    input.value = null;
  };

  reader.readAsArrayBuffer(file);
};

  const parseExcelToDataGroup = (summarySheet, detailsSheet) => {
    const dataGroup = {};
    const [headerRow, ...dataRows] = summarySheet;
    for (const row of dataRows) {
      const key = row[0];
      const item = {};
      headerRow.forEach((header, i) => {
        if (header === "key") return;
        try {
          item[header] = JSON.parse(row[i]);
        } catch {
          item[header] = row[i];
        }
      });
      dataGroup[key] = item;
    }
    let i = 0;
    while (i < detailsSheet.length) {
      const keyRow = detailsSheet[i];
      if (!keyRow || !keyRow[0]) { i++; continue; }
      const key = keyRow[0];
      const subHeader = detailsSheet[i + 1]?.[0];
      const headers = detailsSheet[i + 2];
      const values = [];
      let j = i + 3;
      while (j < detailsSheet.length && detailsSheet[j]?.length > 0) {
        const row = detailsSheet[j];
        const obj = {};
        headers.forEach((h, idx) => { obj[h] = row[idx]; });
        values.push(obj);
        j++;
      }
      if (!dataGroup[key]) dataGroup[key] = {};
      dataGroup[key][subHeader] = values;
      i = j + 1;
    }
    return dataGroup;
  };

  const exportFrequencies = async (type = "both") => {
    const endpoint = "/export_frequencies";
    const requestData = { projectId: projectId };
    if (type !== "both") requestData.type = type;
    requestData.type = type;
    requestData.sigTest = sigText;
    try {
      const response = await fetch(`${apiService.baseURL}${endpoint}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      });
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = type === "both" ? `frequency_data_${projectId}.xlsx` : `frequency_data_${projectId}_${type}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Export error:", error);
    }
  };

  const downloadTxtFile = (e) => {
    setLoading(true);
    setExportOption(e);
    const body = JSON.stringify({
      projectId,
      dataList: dataGroup,
      banners,
      user: powner,
      project: JSON.stringify(selectedProject),
      client: JSON.stringify(selectedClient),
      bilendi: isbilendi,
      type: e,
    });
    if (e === "Wincross") {
      fetch(`${apiService.baseURL}/generate-file`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body,
      })
        .then((response) => {
          if (!response.ok) throw new Error(`Server error ${response.status}`);
          return response.blob();
        })
        .then((blob) => {
          const url = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = "tabs.JOB";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
          setLoading(false);
          toast.success("File generated and downloaded successfully!");
        })
        .catch((error) => {
          toast.error("Error generating file. Contact Administrator.");
          setLoading(false);
        });
    } else {
      fetch(`${apiService.baseURL}/generate-file`, {
        method: "POST",
        headers: { "Content-Type": "application/json", "Authorization": `Bearer ${apiService.getToken()}` },
        body,
      })
        .then((response) => response.json())
        .then((data) => {
          setLoading(false);
          toast.success("File generated successfully!");
        })
        .catch((error) => {
          toast.error("Error generating file. Contact Administrator.");
          setLoading(false);
        });
    }
  };

  const handleTabChange = (tabName) => {
    if (tabName === "") {
      setActiveTab("");
      setselectedBanner(null);
    } else {
      const check = banners.filter((x) => x.name === tabName)[0];
      setActiveTab(check.name);
      setselectedBanner(check);
    }
  };

const downloadJson = () => {
    if (!dataGroup) {
        console.error('No dataGroup provided');
        return;
    }
    
    let fileContent = '';
    if (typeof dataGroup === 'string') {
        fileContent = dataGroup;
    } else if (typeof dataGroup === 'object') {
        // Sort the object by 'order' property
        const sortedObj = {};
        const sortedKeys = Object.keys(dataGroup).sort((a, b) => {
            const orderA = dataGroup[a]?.order !== undefined ? Number(dataGroup[a].order) : Infinity;
            const orderB = dataGroup[b]?.order !== undefined ? Number(dataGroup[b].order) : Infinity;
            
            const validOrderA = !isNaN(orderA) ? orderA : Infinity;
            const validOrderB = !isNaN(orderB) ? orderB : Infinity;
            
            return validOrderA - validOrderB;
        });
        
        for (const key of sortedKeys) {
            sortedObj[key] = dataGroup[key];
        }
        
        fileContent = JSON.stringify(sortedObj, null, 2);
    } else {
        fileContent = String(dataGroup);
    }
    
    const blob = new Blob([fileContent], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `dataGroup_${new Date().toISOString().slice(0, 19)}.txt`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};

  const handleRunTables = async (opts = {}) => {
    if (runTablesLoading) return;
    setRunTablesLoading(true);
    setRunTablesStatus("running");
    try {
      const payload = {
        projectId:           projectId,
        selectedBanner:      selectedBanner || null,
        selectedWeights:     selectedWeights || null,
        exportType:          opts.exportType      ?? exportType,
        sigTest:             opts.sigTest         ?? runTablesSigTest,
        layout:              opts.layout          ?? runTablesLayout,
        survationFormat:     opts.survationFormat ?? runTablesSurvation,
        bilendiFormat:          opts.bilendiFormat   ?? isbilendi,
        bilendiSeparateSheet:   bilendiSeparateSheet,
        refreshData:         opts.refreshData     ?? false,
        user:                powner,
        // ── Master table settings ───────────────────────────────────────
        ...tableSettings,
        // ── Output sets ────────────────────────────────────────────────
        outputSets:              outputSets,
        separateExcelPerOutput:  tableSettings.separateExcelPerOutput || false,
      };
      const response = await fetch(`${apiService.baseURL}/run_all_tables`, {
        method:  "POST",
        headers: { "Content-Type": "application/json" },
        body:    JSON.stringify(payload),
      });
      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.error || `Server error ${response.status}`);
      }
      const contentType = response.headers.get("Content-Type") || "";
      const blob        = await response.blob();
      const url         = window.URL.createObjectURL(blob);
      const a           = document.createElement("a");
      a.href            = url;
      const bn          = selectedBanner?.name || "Topline";
      const ext         = contentType.includes("zip") ? "zip" : "xlsx";
      a.download        = `tables_${projectId}_${bn}.${ext}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      setRunTablesStatus("done");
      setTimeout(() => setRunTablesStatus("idle"), 3000);
    } catch (err) {
      toast.error(`Run Tables failed: ${err.message}`);
      setRunTablesStatus("error");
      setTimeout(() => setRunTablesStatus("idle"), 4000);
    } finally {
      setRunTablesLoading(false);
    }
  };

  const handleExportTypeChange = (event) => {
    setExportType(event);
    exportFrequencies(event);
  };

  const toggleModal = () => setIsModalOpen((prev) => !prev);
  const atoggleModal = () => setIsaModalOpen((prev) => !prev);
  const acloseModalAndUpdateButtons = () => setIsaModalOpen(false);



const handleUploadWithFetch = async (e) => {
  
  setLoading(true);
  const selectedFile = e.target.files[0];
  if (!selectedFile || !projectId) return;

  const formData = new FormData();
  formData.append('file', selectedFile);
  formData.append('banner', JSON.stringify(saveBanner));
let apiservice = saveBanner ? 'upload-banner-json' : 'upload-qgroup-json';
  

  
  try {
    const response = await fetch(`${apiService.baseURL}/api/${apiservice}/${projectId}`, {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Upload failed');
    }

    const data = await response.json();
    toast.success('Successfully uploaded');
  } catch (error) {
    toast.error(error.message);
  } finally {
    
e.target.value = null;
setLoading(false);
  }
};

const exportToExcel = () => {
    // Sort the entries without modifying original dataGroup
    const sortedEntries = Object.entries(dataGroup)
        .sort((a, b) => {
            const orderA = a[1]?.order !== undefined ? Number(a[1].order) : Infinity;
            const orderB = b[1]?.order !== undefined ? Number(b[1].order) : Infinity;
            
            // Handle NaN values
            const validOrderA = !isNaN(orderA) ? orderA : Infinity;
            const validOrderB = !isNaN(orderB) ? orderB : Infinity;
            
            return validOrderA - validOrderB;
        });
    
    const rows = [];
    const headersSet = new Set();
    
    for (const [key, item] of sortedEntries) {
        const row = { key };
        for (const prop in item) {
            if (!["Rows","values","reverseGrid","grid","Cols","varName","rankSumary","valueLabels"].includes(prop)) {
                if (typeof item[prop] === "object" && item[prop] !== null) row[prop] = JSON.stringify(item[prop]);
                else row[prop] = item[prop];
                headersSet.add(prop);
            }
        }
        rows.push(row);
    }
    
    const headers = ["key", ...Array.from(headersSet)];
    const summaryData = [headers];
    for (const row of rows) {
        const rowData = headers.map((header) => row[header] ?? "");
        summaryData.push(rowData);
    }
    const summarySheet = XLSX.utils.aoa_to_sheet(summaryData);
    
    const detailData = [];
    for (const [key, item] of sortedEntries) {
        for (const items in item) {
            if (["Rows","values","reverseGrid","grid","Cols","varName","rankSumary","valueLabels"].includes(items)) {
                const subHeaders = item[items];
                if (Array.isArray(subHeaders) && subHeaders.length > 0) {
                    detailData.push([key]);
                    detailData.push([items]);
                    const columnHeaders = Object.keys(subHeaders[0]);
                    detailData.push(columnHeaders);
                    for (const obj of subHeaders) {
                        const row = columnHeaders.map((col) => obj[col] ?? "");
                        detailData.push(row);
                    }
                    detailData.push([]);
                }
            }
        }
    }
    
    const detailSheet = XLSX.utils.aoa_to_sheet(detailData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, summarySheet, "Summary");
    XLSX.utils.book_append_sheet(workbook, detailSheet, "Details");
    XLSX.writeFile(workbook, "DataGroupExport.xlsx");
};
    // const features = user?.user?.organization?.data_tables_feature || user?.organization.data_tables_feature || {};
    // const expfeatures = allExportTypes.filter(item => features[item.feature] === true);
    const features = user?.user?.organization?.data_tables_feature || user?.organization?.data_tables_feature;
    if (!features) {
      return <div>Loading...</div>;
    }
    const expfeatures = allExportTypes.filter(item => features[item.feature] === true);
console.log(dataGroup);
  return (
    <>
      <div>
        {/* Control Panel */}
        <div className={`control-panel ${isControlPanelOpen ? "open" : "closed"}`}>
          <div className="control-section">
            <h4>Data Management</h4>
            <div className="control-group">

              {/* ── Export row ── */}
              
              <div className="dm-action-row">
                {features?.export_excel && (
                <button className="dm-action-btn dm-action-btn--primary" onClick={() => exportToExcel()} title="Export data to Excel">
                  <span className="dm-action-icon"><FontAwesomeIcon icon={faFileExport} /></span>
                  <span className="dm-action-label">Export Excel</span>
                </button>
                )}
              
                {features?.json_ai && (
                <button className="dm-action-btn dm-action-btn--success" onClick={downloadJson} title="Download JSON for AI">
                  <span className="dm-action-icon"><FontAwesomeIcon icon={faRobot} /></span>
                  <span className="dm-action-label">JSON AI</span>
                </button>
                )}
              </div>

              {/* ── Unified Import card ── */}
              <div className="dm-upload-group">
                
                <div className="dm-upload-label-row">
                  <FontAwesomeIcon icon={faUpload} className="dm-section-icon" />
                  <span className="dm-section-title">Import / Upload</span>
                </div>

                {/* Hidden shared file input */}
                <input
                  ref={sharedFileRef}
                  type="file"
                  style={{ display: "none" }}
                  onChange={onSharedFileChange}
                />

                {/* Excel import — separate accept, direct handler */}
                {features?.import_excel && (
                <label className="dm-action-btn dm-action-btn--upload dm-action-btn--full" title="Choose Excel file to import">
                  <span className="dm-action-icon"><FontAwesomeIcon icon={faFileExcel} /></span>
                  <span className="dm-action-label">{fileName ? fileName : "Import Excel"}</span>
                  <input type="file" accept=".xlsx,.xls" onChange={handleFileUpload} style={{ display: "none" }} />
                </label>
                )}

                {/* Common JSON drop-zone */}
                {features?.select_json && (
                <div
                  className={`dm-dropzone ${sharedFile ? "dm-dropzone--has-file" : ""}`}
                  onClick={() => openSharedPicker(".json")}
                  title="Click to select a JSON file"
                >
                  <FontAwesomeIcon icon={sharedFile ? faCheckCircle : faFileAlt} className={`dm-dropzone-icon ${sharedFile ? "dm-dropzone-icon--ok" : ""}`} />
                  <span className="dm-dropzone-text">
                    {sharedFile ? sharedFile.name : "Click to select JSON file"}
                  </span>
                  {sharedFile && (
                    <span
                      className="dm-dropzone-clear"
                      title="Clear selection"
                      onClick={(e) => { e.stopPropagation(); setSharedFile(null); }}
                    >
                      <FontAwesomeIcon icon={faTimes} />
                    </span>
                  )}
                </div>
                )}

                {/* Function dispatch buttons */}
                <div className="dm-dispatch-grid">
                  {features?.tab_specs && (
                  <button
                    className={`dm-dispatch-btn dm-dispatch-btn--tabspecs`}
                    onClick={dispatchTabSpecs}
                    title="Send file to Tab Specs"
                    
                  >
                    <FontAwesomeIcon icon={faTable} />
                    <span>Tab Specs</span>
                  </button>
                  )}
                  
                  {features?.table_json && (
                  <button
                    className={`dm-dispatch-btn ${!sharedFile ? "dm-dispatch-btn--disabled" : "dm-dispatch-btn--tablejson"}`}
                    onClick={dispatchTableJson}
                    title="Upload as Table JSON"
                    disabled={!sharedFile}
                  >
                    <FontAwesomeIcon icon={faFileAlt} />
                    <span>Table JSON</span>
                  </button>
                  )}

                  {features?.banner && (
                  <button
                    className={`dm-dispatch-btn ${!sharedFile ? "dm-dispatch-btn--disabled" : "dm-dispatch-btn--banner"}`}
                    onClick={dispatchBannerJson}
                    title="Upload as Banner JSON"
                    disabled={!sharedFile}
                  >
                    <FontAwesomeIcon icon={faArrowsLeftRight} />
                    <span>Banner</span>
                  </button>
                  )}

                  {features?.scripting && (
                  <button
                    className={`dm-dispatch-btn ${!sharedFile ? "dm-dispatch-btn--disabled" : "dm-dispatch-btn--scripting"}`}
                    onClick={dispatchScriptingJson}
                    title="Save to sqgroup_json (Scripting)"
                    disabled={!sharedFile}
                  >
                    <FontAwesomeIcon icon={faSave} />
                    <span>Scripting</span>
                  </button>
                  )}
                </div>
              </div>

              {/* ── Utility ── */}
              {features?.update_locations && (
              <button className="dm-action-btn dm-action-btn--warning dm-action-btn--full" onClick={scanAndUpdateVarNameLocations} title="Scan all varNames and update locations" disabled={loading}>
                <span className="dm-action-icon"><FontAwesomeIcon icon={faArrowsLeftRight} /></span>
                <span className="dm-action-label">Update Locations (Numeric Only)</span>
              </button>
              )}

            </div>
          </div>
          <div className="control-section">
            <h4>Analysis Tools</h4>

            <div className="control-group">

              {/* ── Action buttons ── */}
              <div className="dm-action-row">
                {features?.properties && (
                <button className="dm-action-btn dm-action-btn--outline" onClick={() => toggleModal()} title="Update Properties">
                  <span className="dm-action-icon"><FontAwesomeIcon icon={faGear} /></span>
                  <span className="dm-action-label">Properties</span>
                </button>
                )}
                {features?.append_variable && (
                <button className="dm-action-btn dm-action-btn--outline" onClick={() => atoggleModal()} title="Append Variable">
                  <span className="dm-action-icon"><FontAwesomeIcon icon={faPlus} /></span>
                  <span className="dm-action-label">Append Variable</span>
                </button>
                )}
              </div>

              {/* ── Toggle cards ── */}
              <div className="at-toggle-cards">
                {features?.sig_test && (
                <label className={`at-toggle-card ${sigText ? "at-toggle-card--on" : ""}`} onClick={() => setsigText(v => !v)}>
                  <div className="at-toggle-card-left">
                    <span className="at-toggle-card-icon"><FontAwesomeIcon icon={faChartBar} /></span>
                    
                    <div>
                      <span className="at-toggle-card-title">Sig Test</span>
                      <span className="at-toggle-card-desc">Significance testing</span>
                    </div>
                    
                  </div>
                  <div className="at-toggle-wrap">
                    <div className={`dm-toggle-track ${sigText ? "dm-toggle-track--on" : ""}`}><div className="dm-toggle-thumb" /></div>
                  </div>
                </label>
                )}
                {features?.auto_refresh && (
                <label className={`at-toggle-card ${refreshData ? "at-toggle-card--on" : ""}`} onClick={() => setRefreshData(v => !v)}>
                  <div className="at-toggle-card-left">
                    <span className="at-toggle-card-icon"><FontAwesomeIcon icon={faRefresh} /></span>
                    <div>
                      <span className="at-toggle-card-title">Auto Refresh</span>
                      <span className="at-toggle-card-desc">Live data updates</span>
                    </div>
                  </div>
                  <div className="at-toggle-wrap">
                    <div className={`dm-toggle-track ${refreshData ? "dm-toggle-track--on" : ""}`}><div className="dm-toggle-thumb" /></div>
                  </div>
                </label>
                )}
                {features?.bilendi_setup && (
                <label className={`at-toggle-card ${isbilendi ? "at-toggle-card--on" : ""}`} onClick={() => setBilendi(v => !v)}>
                  <div className="at-toggle-card-left">
                    <span className="at-toggle-card-icon"><FontAwesomeIcon icon={faGlobe} /></span>
                    <div>
                      <span className="at-toggle-card-title">Bilendi Setup</span>
                      <span className="at-toggle-card-desc">Bilendi configuration</span>
                    </div>
                  </div>
                  <div className="at-toggle-wrap">
                    <div className={`dm-toggle-track ${isbilendi ? "dm-toggle-track--on" : ""}`}><div className="dm-toggle-thumb" /></div>
                  </div>
                </label>
                )}
                {features?.bilendi_setup && isbilendi && (
                <label className={`at-toggle-card ${bilendiSeparateSheet ? "at-toggle-card--on" : ""}`} onClick={() => setBilendiSeparateSheet(v => !v)}>
                  <div className="at-toggle-card-left">
                    <span className="at-toggle-card-icon"><FontAwesomeIcon icon={faFileExcel} /></span>
                    <div>
                      <span className="at-toggle-card-title">Separate Sheet</span>
                      <span className="at-toggle-card-desc">One question per sheet (Client Reference format)</span>
                    </div>
                  </div>
                  <div className="at-toggle-wrap">
                    <div className={`dm-toggle-track ${bilendiSeparateSheet ? "dm-toggle-track--on" : ""}`}><div className="dm-toggle-thumb" /></div>
                  </div>
                </label>
                )}

                {features?.survation_format && (
                <label className={`at-toggle-card ${runTablesSurvation ? "at-toggle-card--on" : ""}`} onClick={() => setRunTablesSurvation(v => !v)}>
                  <div className="at-toggle-card-left">
                    <span className="at-toggle-card-icon"><FontAwesomeIcon icon={faFileExcel} /></span>
                    <div>
                      <span className="at-toggle-card-title">Survation Format</span>
                      <span className="at-toggle-card-desc">Survation-style table export</span>
                    </div>
                  </div>
                  <div className="at-toggle-wrap">
                    <div className={`dm-toggle-track ${runTablesSurvation ? "dm-toggle-track--on" : ""}`}><div className="dm-toggle-thumb" /></div>
                  </div>
                </label>
                )}
              </div>

            </div>
          </div>
          <div className="control-section">
            <h4>Display Settings</h4>
            <div className="control-group">

              {/* Select Banner */}
              {features?.select_banner && (
              <div className="ds-field">
                <label className="ds-label">
                  <FontAwesomeIcon icon={faArrowsLeftRight} className="ds-icon" />
                  Select Banner
                </label>
                <div className="ds-select-grid">
                  {banners && banners.length > 0 ? (
                    banners.map((b, i) => (
                      <button
                        key={i}
                        className={`ds-chip ${activeTab === b.name ? "ds-chip--active" : ""}`}
                        onClick={() => handleTabChange(b.name)}
                        title={b.name}
                      >
                        {b.name}
                      </button>
                    ))
                  ) : (
                    <span className="ds-empty">No banners available</span>
                  )}
                </div>
              </div>
              )}

              {/* Select Weights */}
              {features?.select_weights && (
              <div className="ds-field">
                <label className="ds-label">
                  <FontAwesomeIcon icon={faWeightScale} className="ds-icon" />
                  Select Weights
                </label>
                <div className="ds-select-grid">
                  {savedWeightings && Object.keys(savedWeightings).length > 0 ? (
                    Object.keys(savedWeightings).map((w, i) => (
                      <button
                        key={i}
                        className={`ds-chip ${selectedWeights === w ? "ds-chip--active" : ""}`}
                        onClick={() => setSelectedWeights(w)}
                        title={w}
                      >
                        {w}
                      </button>
                    ))
                  ) : (
                    <span className="ds-empty">No weights available</span>
                  )}
                </div>
              </div>
              )}

              {/* Export Type */}
              {features?.select_weights && (
              <div className="ds-field">
                <label className="ds-label">
                  <FontAwesomeIcon icon={faFileExport} className="ds-icon" />
                  Export Type
                </label>
                <div className="ds-select-grid">
                  {expfeatures && expfeatures.length > 0 ? (
                    expfeatures.map((x, i) => (
                      <button
                        key={i}
                        className={`ds-chip ${exportOption === x.type ? "ds-chip--active" : ""}`}
                        onClick={() => downloadTxtFile(x.type)}
                        title={x.text}
                      >
                        {x.text}
                      </button>
                    ))
                  ) : (
                    <span className="ds-empty">No export types available</span>
                  )}
                </div>
              </div>
              )}

              {/* Run Tables */}
              {features?.run_tables && (
              <div className="ds-field">
                <label className="ds-label">
                  <FontAwesomeIcon icon={faFileExcel} className="ds-icon" />
                  Run Tables
                  <span style={{ marginLeft: 6, fontSize: 10, color: "#8a9bb0", fontWeight: 400 }}>
                    (all questions → Excel)
                  </span>
                </label>
                {/* Option chips: which data to include */}
                <div className="ds-select-grid" style={{ marginBottom: 6 }}>
                  {[
                    { label: "Freq + %",   value: "both"      },
                    { label: "% Only",     value: "percent"   },
                    { label: "Freq Only",  value: "frequency" },
                  ].map((opt) => (
                    <button
                      key={opt.value}
                      className={`ds-chip ${exportType === opt.value ? "ds-chip--active" : ""}`}
                      onClick={() => setExportType(opt.value)}
                      title={opt.label}
                      disabled={runTablesLoading}
                    >
                      {opt.label}
                    </button>
                  ))}
                </div>
                

                {/* Layout chips: rows vs cols */}
                <div style={{ fontSize: 10, color: "#8a9bb0", marginBottom: 3, marginTop: 2 }}>
                  Export layout
                </div>
                <div className="ds-select-grid" style={{ marginBottom: 6 }}>
                  {[
                    { label: "Row format",  value: "rows", title: "Freq / % / Sig on separate rows per response" },
                    { label: "Col format",  value: "cols", title: "Freq | % | Sig as sub-columns per banner break" },
                  ].map((opt) => (
                    <button
                      key={opt.value}
                      className={`ds-chip ${runTablesLayout === opt.value ? "ds-chip--active" : ""}`}
                      onClick={() => setRunTablesLayout(opt.value)}
                      title={opt.title}
                      disabled={runTablesLoading}
                    >
                      {opt.label}
                    </button>
                  ))}
                </div>

                {/* Toggles: Sig Testing */}
                {[
                  {
                    label: "Sig Testing",
                    value: runTablesSigTest,
                    set: setRunTablesSigTest,
                    title: "Include significance test letters in export",
                  },
                ].map(({ label, value, set, title }) => (
                  <div
                    key={label}
                    title={title}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      marginBottom: 7,
                      cursor: runTablesLoading ? "not-allowed" : "pointer",
                      userSelect: "none",
                    }}
                    onClick={() => !runTablesLoading && set((v) => !v)}
                  >
                    <div
                      style={{
                        width: 32,
                        height: 17,
                        borderRadius: 9,
                        background: value ? "#2563eb" : "#334155",
                        position: "relative",
                        transition: "background 0.2s",
                        flexShrink: 0,
                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          top: 2,
                          left: value ? 17 : 2,
                          width: 13,
                          height: 13,
                          borderRadius: "50%",
                          background: "#fff",
                          transition: "left 0.2s",
                        }}
                      />
                    </div>
                    <span style={{ fontSize: 11, color: value ? "#60a5fa" : "#8a9bb0" }}>
                      {label}
                    </span>
                  </div>
                ))}

                {/* ── Settings gear button ───────────────────────── */}
                <button
                  onClick={() => setSettingsModalOpen(true)}
                  disabled={runTablesLoading}
                  title="Decimal places, base rows, statistics display"
                  style={{
                    width: "100%", display: "flex", alignItems: "center", justifyContent: "center",
                    gap: 7, padding: "6px 10px", borderRadius: 6, marginBottom: 8,
                    border: "1px solid #334155", background: "#131f2e",
                    color: "#94a3b8", fontSize: 11, cursor: runTablesLoading ? "not-allowed" : "pointer",
                  }}
                >
                  <FontAwesomeIcon icon={faGear} style={{ fontSize: 11 }} />
                  Formatting &amp; Display Settings
                </button>

                {/* Primary Run button */}
                <button
                  className="runtables-btn"
                  onClick={() => handleRunTables()}
                  disabled={runTablesLoading}
                  title="Run frequencies for all questions and export to Excel"
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 8,
                    padding: "9px 14px",
                    borderRadius: 8,
                    border: "none",
                    cursor: runTablesLoading ? "not-allowed" : "pointer",
                    fontWeight: 600,
                    fontSize: 13,
                    background: runTablesStatus === "done"  ? "linear-gradient(135deg,#16a34a,#15803d)"
                               : runTablesStatus === "error" ? "linear-gradient(135deg,#dc2626,#b91c1c)"
                               : "linear-gradient(135deg,#1d4ed8,#2563eb)",
                    color: "#fff",
                    opacity: runTablesLoading ? 0.65 : 1,
                    transition: "background 0.25s, opacity 0.2s",
                    marginBottom: 4,
                  }}
                >
                  {runTablesLoading ? (
                    <>
                      <FontAwesomeIcon icon={faSpinner} spin />
                      Running all tables…
                    </>
                  ) : runTablesStatus === "done" ? (
                    <>
                      <FontAwesomeIcon icon={faCheckCircle} />
                      Downloaded!
                    </>
                  ) : runTablesStatus === "error" ? (
                    <>
                      <FontAwesomeIcon icon={faTimes} />
                      Failed — Retry
                    </>
                  ) : (
                    <>
                      <FontAwesomeIcon icon={faFileExcel} />
                      Run Tables
                    </>
                  )}
                </button>

                {/* Refresh option */}
                <button
                  className="runtables-btn-secondary"
                  onClick={() => handleRunTables({ refreshData: true })}
                  disabled={runTablesLoading}
                  title="Recalculate all tables (ignore DB cache) and export"
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 6,
                    padding: "6px 10px",
                    borderRadius: 7,
                    border: "1px solid #334155",
                    cursor: runTablesLoading ? "not-allowed" : "pointer",
                    fontWeight: 500,
                    fontSize: 11,
                    background: "#1e2533",
                    color: "#94a3b8",
                    opacity: runTablesLoading ? 0.5 : 1,
                    transition: "background 0.2s",
                  }}
                  onMouseEnter={(e) => { if (!runTablesLoading) e.currentTarget.style.background = "#263145"; }}
                  onMouseLeave={(e) => { e.currentTarget.style.background = "#1e2533"; }}
                >
                  <FontAwesomeIcon icon={faRefresh} />
                  Force Recalculate + Export
                </button>
              </div>
              )}
            </div>
          </div>
        </div>

        {!isPropertiesShow ? (
          <div className="data-tables-container">
            <div className="page-header">
              <h2>Frequency Data: {selectedTitle}</h2>
              <div className="header-actions">
                <button className={`btn btn-toggle ${isControlPanelOpen ? "active" : ""}`} onClick={() => setIsControlPanelOpen(!isControlPanelOpen)} title={isControlPanelOpen ? "Hide Control Panel" : "Show Control Panel"}>
                  <FontAwesomeIcon icon={faGear} />
                </button>
                <button className="btn btn-secondary" onClick={() => handleShowProperties()} title="Global Settings">
                  <FontAwesomeIcon icon={faGlobe} /><span>Global</span>
                </button>
              </div>
            </div>
            <div className="data-display-area">
              <>
                <div className="data-content">
                  {!isCrossTab && frequencyData && (frequencyData.type === "SingleResponse" || frequencyData.type === "Numeric") && displayMode === "table" && (
                    <FrequencyTableComponent freq_table={frequencyData} displaySettings={fullDisplaySettings} />
                  )}
                  {!isCrossTab && frequencyData && frequencyData.type === "Multiple2DGrid" && displayMode === "table" && (
                    <MultiResponse varProperties={frequencyData} displaySettings={fullDisplaySettings} />
                  )}
                  {!isCrossTab && frequencyData && (frequencyData.type === "Single2DGrid" || frequencyData.type === "Numeric2DGrid") && displayMode === "table" && (
                    <DataGrid gridData={frequencyData} displaySettings={fullDisplaySettings} grid={selectedVariable.grid} reverseGrid={selectedVariable.reverseGrid} />
                  )}
                  {!isCrossTab && frequencyData && (frequencyData.type === "Multiple3DGrid" || frequencyData.type === "Single3DGrid") && displayMode === "table" && (
                    <MultiDataGrid gridData={frequencyData} displaySettings={fullDisplaySettings} />
                  )}
                  {!isCrossTab && frequencyData && frequencyData.type === "Numeric3DGrid" && displayMode === "table" && (
                    <Grid3DData gridData={frequencyData} displaySettings={fullDisplaySettings} />
                  )}
                  {displayMode === "chart" && frequencyData && Object.entries(frequencyData).map(([varName, freq], index) => (
                    <div key={index}><h3>{varName}</h3><MyChartComponent frequencyData={freq} /></div>
                  ))}
                  {isCrossTab && crosstabDisplayData && <CrosstabTable crosstab={crosstabDisplayData} />}
                </div>
              </>
            </div>
            <OpenProperties isOpen={isModalOpen} onClose={closeModalAndUpdateButtons} setdataGroup={setdataGroup} dataGroup={dataGroup} selectedKey={selectedTitle} selectedVariable={selectedVariable} setSelectedVariable={setSelectedVariable} projectId={projectId} />
          </div>
        ) : (
          <div className="properties-view">
            <div className="page-header" style={{ marginBottom: "24px" }}>
              <h2>Global Settings</h2>
              <div className="header-actions">
                <button className={`btn btn-toggle ${isControlPanelOpen ? "active" : ""}`} onClick={() => setIsControlPanelOpen(!isControlPanelOpen)} title={isControlPanelOpen ? "Hide Control Panel" : "Show Control Panel"}>
                  <FontAwesomeIcon icon={faGear} />
                </button>
              </div>
            </div>
            <button className="btn btn-back" onClick={() => handleShowProperties()} style={{ marginBottom: "24px" }}>
              <FontAwesomeIcon icon={faArrowLeft} /><span>Back to Tables</span>
            </button>
            <PropertiesComponent setdataGroup={setdataGroup} selectedVariable={selectedVariable} selectedKey={selectedTitle} dataGroup={dataGroup} setSelectedVariable={setSelectedVariable} projectId={projectId} nets={nets} setNets={setNets} />
          </div>
        )}
      </div>

      {/* ── AI Tab Specs Modal ─────────────────────────────────────────────── */}
      {isTabSpecsModalOpen && (
        <div
          className="modal-overlay"
          onClick={status === "success" ? undefined : toggleTabSpecsModal}
          style={status === "success" ? { alignItems: "stretch", padding: 0 } : {}}
        >
          <div
            className="modal-content"
            onClick={e => e.stopPropagation()}
            style={status === "success" ? {
              width: "100vw", maxWidth: "100vw", height: "100vh", maxHeight: "100vh",
              borderRadius: 0, margin: 0, display: "flex", flexDirection: "column", overflow: "hidden"
            } : {}}
          >
            <style>{`
              /* ── Base wrapper ───────────────────────────────────── */
              .ts-wrapper {
                font-family: 'Segoe UI', system-ui, sans-serif;
                background: #0f1117;
                color: #e2e8f0;
                border-radius: 16px;
                width: 580px;
                max-width: 95vw;
                max-height: 92vh;
                overflow-y: auto;
                box-shadow: 0 24px 64px rgba(0,0,0,0.6);
                display: flex;
                flex-direction: column;
              }
              /* ── Full-screen wrapper (post-success) ─────────────── */
              .ts-wrapper--fullscreen {
                width: 100%;
                height: 100%;
                max-width: 100%;
                max-height: 100%;
                border-radius: 0;
                overflow: hidden;
                display: flex;
                flex-direction: column;
              }
              .ts-header {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 14px 20px;
                border-bottom: 1px solid #1e2533;
                flex-shrink: 0;
                background: #0c0f16;
              }
              .ts-header h2 {
                margin: 0;
                font-size: 15px;
                font-weight: 600;
                color: #f1f5f9;
                display: flex;
                align-items: center;
                gap: 8px;
              }
              .ts-header h2 svg { color: #6366f1; }
              .ts-header-actions { display: flex; align-items: center; gap: 8px; }
              .ts-close-btn {
                background: none;
                border: none;
                color: #64748b;
                cursor: pointer;
                font-size: 16px;
                padding: 4px 8px;
                border-radius: 6px;
                transition: color 0.2s, background 0.2s;
              }
              .ts-close-btn:hover { color: #f1f5f9; background: #1e2533; }

              /* ── Upload body ────────────────────────────────────── */
              .ts-body { padding: 20px 24px; display: flex; flex-direction: column; gap: 16px; flex-shrink: 0; }
              .ts-divider {
                display: flex; align-items: center; gap: 10px;
                font-size: 11px; color: #475569; text-transform: uppercase; letter-spacing: 0.08em;
              }
              .ts-divider::before, .ts-divider::after { content: ''; flex: 1; height: 1px; background: #1e2533; }
              .ts-file-zone {
                background: #131822; border: 1.5px dashed #2a3344; border-radius: 12px;
                padding: 14px 16px; transition: border-color 0.2s, background 0.2s;
              }
              .ts-file-zone:hover { border-color: var(--accent, #6366f1); }
              .ts-file-zone--filled {
                border-style: solid; border-color: var(--accent, #6366f1);
                background: color-mix(in srgb, var(--accent, #6366f1) 6%, #131822);
              }
              .ts-zone-header { display: flex; align-items: center; gap: 8px; margin-bottom: 10px; }
              .ts-zone-icon { color: var(--accent, #6366f1); font-size: 14px; }
              .ts-zone-label { font-size: 13px; font-weight: 600; color: #cbd5e1; flex: 1; }
              .ts-zone-clear { background: none; border: none; color: #64748b; cursor: pointer; font-size: 12px; padding: 2px 6px; border-radius: 4px; }
              .ts-zone-clear:hover { color: #f87171; }
              .ts-drop-label { display: flex; flex-direction: column; align-items: center; gap: 4px; cursor: pointer; color: #475569; font-size: 13px; padding: 8px 0; }
              .ts-drop-label svg { font-size: 18px; margin-bottom: 2px; }
              .ts-drop-label small { font-size: 11px; color: #334155; }
              .ts-drop-label:hover { color: #94a3b8; }
              .ts-file-info { display: flex; align-items: center; gap: 10px; font-size: 13px; }
              .ts-check { color: var(--accent, #22c55e); font-size: 16px; }
              .ts-file-name { color: #e2e8f0; font-weight: 500; word-break: break-all; }
              .ts-file-size { color: #64748b; font-size: 11px; margin-top: 2px; }
              .ts-status { border-radius: 10px; padding: 12px 16px; font-size: 13px; display: flex; align-items: flex-start; gap: 10px; }
              .ts-status--processing { background: #1e2b4a; color: #93c5fd; }
              .ts-status--success { background: #14281e; color: #86efac; border: 1px solid #166534; }
              .ts-status--error { background: #2a1518; color: #fca5a5; border: 1px solid #7f1d1d; }
              .ts-status svg { margin-top: 1px; flex-shrink: 0; }
              .ts-spin { animation: ts-rotate 1s linear infinite; }
              @keyframes ts-rotate { to { transform: rotate(360deg); } }
              .ts-progress-track { background: #1e2533; border-radius: 999px; height: 4px; overflow: hidden; }
              .ts-progress-fill { height: 100%; background: linear-gradient(90deg, #6366f1, #8b5cf6); border-radius: 999px; transition: width 0.4s ease; }
              .ts-footer { display: flex; justify-content: flex-end; gap: 10px; padding: 16px 24px 20px; border-top: 1px solid #1e2533; flex-shrink: 0; }
              .ts-btn { display: flex; align-items: center; gap: 7px; padding: 9px 18px; border-radius: 8px; font-size: 13px; font-weight: 500; cursor: pointer; border: none; transition: opacity 0.2s, background 0.2s; }
              .ts-btn:disabled { opacity: 0.45; cursor: not-allowed; }
              .ts-btn--ghost { background: #1e2533; color: #94a3b8; }
              .ts-btn--ghost:hover:not(:disabled) { background: #263145; color: #e2e8f0; }
              .ts-btn--primary { background: linear-gradient(135deg, #6366f1, #8b5cf6); color: #fff; }
              .ts-btn--primary:hover:not(:disabled) { opacity: 0.88; }
              .ts-btn--sm { padding: 6px 12px; font-size: 12px; }

              /* ── Split-screen layout ────────────────────────────── */
              .ts-split-body {
                flex: 1;
                display: flex;
                flex-direction: row;
                overflow: hidden;
                min-height: 0;
              }
              .ts-pane {
                flex: 1;
                display: flex;
                flex-direction: column;
                overflow: hidden;
                border-right: 1px solid #1e2533;
                min-width: 0;
              }
              .ts-pane:last-child { border-right: none; }
              .ts-pane-header {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 8px 14px;
                background: #0c0f16;
                border-bottom: 1px solid #1e2533;
                flex-shrink: 0;
              }
              .ts-pane-title {
                font-size: 11px;
                font-weight: 700;
                text-transform: uppercase;
                letter-spacing: 0.08em;
                display: flex;
                align-items: center;
                gap: 6px;
              }
              .ts-pane-title--json { color: #6366f1; }
              .ts-pane-title--banner { color: #f59e0b; }
              .ts-pane-editor {
                flex: 1;
                overflow: auto;
                background: #080b10;
                min-height: 0;
              }
              .ts-pane-editor::-webkit-scrollbar { width: 5px; height: 5px; }
              .ts-pane-editor::-webkit-scrollbar-thumb { background: #2a3344; border-radius: 3px; }
              .ts-json-textarea {
                width: 100%;
                height: 100%;
                min-height: 100%;
                background: transparent;
                border: none;
                outline: none;
                color: #a5f3fc;
                font-family: 'Fira Code', 'Cascadia Code', 'Consolas', monospace;
                font-size: 12px;
                line-height: 1.6;
                padding: 14px;
                resize: none;
                box-sizing: border-box;
              }
              .ts-json-textarea::placeholder { color: #1e2d40; }
              .ts-json-err {
                font-size: 11px;
                color: #f87171;
                padding: 4px 14px 6px;
                background: #1a0a0a;
                border-top: 1px solid #3b1212;
                flex-shrink: 0;
              }

              /* ── Bottom chat area ───────────────────────────────── */
              .ts-bottom {
                display: flex;
                flex-direction: column;
                border-top: 2px solid #1e2533;
                flex-shrink: 0;
                background: #0c0f16;
                max-height: 38vh;
              }
              .ts-chat-header {
                padding: 8px 16px;
                font-size: 11px;
                font-weight: 700;
                color: #6366f1;
                text-transform: uppercase;
                letter-spacing: 0.07em;
                display: flex;
                align-items: center;
                gap: 7px;
                border-bottom: 1px solid #1e2533;
                flex-shrink: 0;
              }
              .ts-chat-body {
                overflow-y: auto;
                padding: 10px 16px;
                display: flex;
                flex-direction: column;
                gap: 10px;
                flex: 1;
                min-height: 60px;
                background: #080b10;
              }
              .ts-chat-body::-webkit-scrollbar { width: 4px; }
              .ts-chat-body::-webkit-scrollbar-thumb { background: #2a3344; border-radius: 2px; }
              .ts-msg { max-width: 88%; padding: 8px 12px; border-radius: 10px; font-size: 13px; line-height: 1.5; white-space: pre-wrap; word-break: break-word; }
              .ts-msg--user { align-self: flex-end; background: linear-gradient(135deg, #4f46e5, #7c3aed); color: #fff; border-bottom-right-radius: 3px; }
              .ts-msg--assistant { align-self: flex-start; background: #131822; color: #cbd5e1; border-bottom-left-radius: 3px; border: 1px solid #1e2533; }
              .ts-msg--streaming::after { content: '▋'; display: inline-block; margin-left: 2px; animation: ts-blink 0.8s steps(1) infinite; }
              @keyframes ts-blink { 0%,100% { opacity: 1; } 50% { opacity: 0; } }
              .ts-chat-empty { color: #334155; font-size: 12px; text-align: center; padding: 16px 0; line-height: 1.6; }
              .ts-chat-input-row { display: flex; align-items: flex-end; gap: 8px; padding: 8px 14px 10px; border-top: 1px solid #1e2533; flex-shrink: 0; }
              .ts-chat-input { flex: 1; background: #131822; border: 1.5px solid #2a3344; border-radius: 8px; color: #e2e8f0; font-size: 13px; padding: 8px 12px; outline: none; resize: none; font-family: inherit; line-height: 1.4; max-height: 80px; transition: border-color 0.2s; }
              .ts-chat-input:focus { border-color: #6366f1; }
              .ts-chat-input::placeholder { color: #475569; }
              .ts-chat-send { background: linear-gradient(135deg, #6366f1, #8b5cf6); border: none; border-radius: 8px; color: #fff; cursor: pointer; font-size: 14px; padding: 9px 13px; transition: opacity 0.2s; flex-shrink: 0; }
              .ts-chat-send:disabled { opacity: 0.4; cursor: not-allowed; }
              .ts-chat-send:hover:not(:disabled) { opacity: 0.85; }

              /* ── JSON validity badge ────────────────────────────── */
              .ts-badge {
                font-size: 10px; font-weight: 600; padding: 2px 7px; border-radius: 999px;
                letter-spacing: 0.04em; flex-shrink: 0;
              }
              .ts-badge--ok { background: #14532d; color: #86efac; }
              .ts-badge--err { background: #7f1d1d; color: #fca5a5; }
            `}</style>

            {status !== "success" ? (
              /* ── UPLOAD PHASE: narrow modal ── */
              <div className="ts-wrapper">
                <div className="ts-header">
                  <h2><FontAwesomeIcon icon={faRobot} /> AI Tab Specs Processor</h2>
                  <button className="ts-close-btn" onClick={toggleTabSpecsModal}>
                    <FontAwesomeIcon icon={faTimes} />
                  </button>
                </div>

                <div className="ts-body">
                  <div className="ts-divider">Upload files</div>

                  {/* Tab Specification zone */}
                  <div
                    className={`ts-file-zone ${tabSpecFile ? "ts-file-zone--filled" : ""}`}
                    style={{ "--accent": "#10b981" }}
                    onDrop={makeDropHandler(setTabSpecFile)}
                    onDragOver={preventDefaults}
                    onDragEnter={preventDefaults}
                  >
                    <div className="ts-zone-header">
                      <FontAwesomeIcon icon={faFileExcel} className="ts-zone-icon" />
                      <span className="ts-zone-label">Tab Specification</span>
                      {tabSpecFile && (
                        <button className="ts-zone-clear" title="Remove file" onClick={() => { setTabSpecFile(null); if (tabSpecInputRef.current) tabSpecInputRef.current.value = ""; }}>
                          <FontAwesomeIcon icon={faTrash} />
                        </button>
                      )}
                    </div>
                    {tabSpecFile ? (
                      <div className="ts-file-info">
                        <FontAwesomeIcon icon={faCheckCircle} className="ts-check" />
                        <div>
                          <div className="ts-file-name">{tabSpecFile.name}</div>
                          <div className="ts-file-size">{formatFileSize(tabSpecFile.size)}</div>
                        </div>
                      </div>
                    ) : (
                      <label className="ts-drop-label">
                        <FontAwesomeIcon icon={faUpload} />
                        <span>Drop file or click to browse</span>
                        <small>.xlsx / .xls / .csv — may be non-English</small>
                        <input ref={tabSpecInputRef} type="file" accept=".xlsx,.xls,.csv" onChange={handleTabSpecChange} style={{ display: "none" }} />
                      </label>
                    )}
                  </div>

                  {/* Questionnaire zone */}
                  <div
                    className={`ts-file-zone ${questionnaireFile ? "ts-file-zone--filled" : ""}`}
                    style={{ "--accent": "#f59e0b" }}
                    onDrop={makeDropHandler(setQuestionnaireFile)}
                    onDragOver={preventDefaults}
                    onDragEnter={preventDefaults}
                  >
                    <div className="ts-zone-header">
                      <FontAwesomeIcon icon={faFileAlt} className="ts-zone-icon" />
                      <span className="ts-zone-label">Questionnaire</span>
                      {questionnaireFile && (
                        <button className="ts-zone-clear" title="Remove file" onClick={() => { setQuestionnaireFile(null); if (questionnaireInputRef.current) questionnaireInputRef.current.value = ""; }}>
                          <FontAwesomeIcon icon={faTrash} />
                        </button>
                      )}
                    </div>
                    {questionnaireFile ? (
                      <div className="ts-file-info">
                        <FontAwesomeIcon icon={faCheckCircle} className="ts-check" />
                        <div>
                          <div className="ts-file-name">{questionnaireFile.name}</div>
                          <div className="ts-file-size">{formatFileSize(questionnaireFile.size)}</div>
                        </div>
                      </div>
                    ) : (
                      <label className="ts-drop-label">
                        <FontAwesomeIcon icon={faUpload} />
                        <span>Drop file or click to browse</span>
                        <small>.xlsx / .xls / .docx — may be non-English</small>
                        <input ref={questionnaireInputRef} type="file" accept=".xlsx,.xls,.docx,.doc" onChange={handleQuestionnaireChange} style={{ display: "none" }} />
                      </label>
                    )}
                  </div>

                  {status === "processing" && (
                    <div className="ts-progress-track">
                      <div className="ts-progress-fill" style={{ width: `${progress}%` }} />
                    </div>
                  )}

                  {status !== "idle" && (
                    <div className={`ts-status ts-status--${status}`}>
                      <FontAwesomeIcon
                        icon={status === "processing" ? faSpinner : status === "success" ? faCheckCircle : faTimes}
                        className={status === "processing" ? "ts-spin" : ""}
                      />
                      <span>{statusMessage}</span>
                    </div>
                  )}
                </div>

                <div className="ts-footer">
                  <button className="ts-btn ts-btn--ghost" onClick={handleReset} disabled={status === "processing"}>Reset</button>
                  <button className="ts-btn ts-btn--ghost" onClick={toggleTabSpecsModal} disabled={status === "processing"}>Cancel</button>
                  <button
                    className="ts-btn ts-btn--primary"
                    onClick={handleProcess}
                    disabled={!tabSpecFile || !questionnaireFile || status === "processing" || status === "success"}
                  >
                    {status === "processing" ? (
                      <><FontAwesomeIcon icon={faSpinner} className="ts-spin" /> Processing…</>
                    ) : (
                      <><FontAwesomeIcon icon={faRobot} /> Process with AI</>
                    )}
                  </button>
                </div>
              </div>
            ) : (
              /* ── SUCCESS PHASE: full-screen split-screen editor ── */
              <SplitScreenEditor
                dataGroup={dataGroup}
                setdataGroup={setdataGroup}
                banners={banners}
                setBanners={setBanners}
                chatMessages={chatMessages}
                chatInput={chatInput}
                setChatInput={setChatInput}
                chatBusy={chatBusy}
                chatBodyRef={chatBodyRef}
                chatInputRef2={chatInputRef2}
                handleChatSend={handleChatSend}
                handleReset={handleReset}
                toggleTabSpecsModal={toggleTabSpecsModal}
                handleSaveToDb={handleSaveToDb}
                saveStatus={saveStatus}
                saveError={saveError}
              />
            )}
          </div>
        </div>
      )}

      <CustomizedVariable isOpen={isAModalOpen} onClose={acloseModalAndUpdateButtons} setcurrentSelectedVariablesset={setcurrentSelectedVariablesset} dataGroup={dataGroup} projectId={projectId} />
      {loading && (<Loader loading={loading} />)}
      <RunTableSettingsModal
        open={settingsModalOpen}
        settings={tableSettings}
        onChange={setTableSettings}
        onClose={() => setSettingsModalOpen(false)}
        hasWeights={!!selectedWeights}
        outputSets={outputSets}
        onChangeOutputSets={handleChangeOutputSets}
      />
    </>
  );
}

// ── Split-screen editor (full-screen, rendered after AI processing) ────────────
function SplitScreenEditor({
  dataGroup, setdataGroup,
  banners, setBanners,
  chatMessages, chatInput, setChatInput,
  chatBusy, chatBodyRef, chatInputRef2,
  handleChatSend, handleReset, toggleTabSpecsModal,
  handleSaveToDb, saveStatus, saveError,
}) {
  // Local editable JSON strings for the two panes
  const [jsonStr,    setJsonStr]    = useState(() => JSON.stringify(dataGroup, null, 2));
  const [bannerStr,  setBannerStr]  = useState(() => JSON.stringify(banners,   null, 2));
  const [jsonErr,    setJsonErr]    = useState(null);
  const [bannerErr,  setBannerErr]  = useState(null);

  // Keep pane content in sync when AI updates the context values
  useEffect(() => { setJsonStr(JSON.stringify(dataGroup, null, 2)); setJsonErr(null); }, [dataGroup]);
  useEffect(() => { setBannerStr(JSON.stringify(banners,   null, 2)); setBannerErr(null); }, [banners]);

  const handleJsonChange = (val) => {
    setJsonStr(val);
    try { setdataGroup(JSON.parse(val)); setJsonErr(null); }
    catch (e) { setJsonErr(e.message); }
  };

  const handleBannerChange = (val) => {
    setBannerStr(val);
    try { const p = JSON.parse(val); if (Array.isArray(p)) { setBanners(p); setBannerErr(null); } else setBannerErr("Must be a JSON array"); }
    catch (e) { setBannerErr(e.message); }
  };

  return (
    <>
    <div style={{ display: "flex", flexDirection: "column", width: "100%", height: "100%", background: "#0f1117", color: "#e2e8f0", fontFamily: "'Segoe UI', system-ui, sans-serif" }}>

      {/* ── Top bar ── */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 18px", borderBottom: "1px solid #1e2533", background: "#0c0f16", flexShrink: 0 }}>
        <span style={{ display: "flex", alignItems: "center", gap: 8, fontWeight: 700, fontSize: 14, color: "#f1f5f9" }}>
          <FontAwesomeIcon icon={faRobot} style={{ color: "#6366f1" }} />
          AI Tab Specs — Review &amp; Edit
        </span>
        <div style={{ display: "flex", gap: 8 }}>
          {/* ── Save to Database button ── */}
          <button
            className="ts-btn ts-btn--sm"
            onClick={handleSaveToDb}
            disabled={saveStatus === "saving"}
            title={saveError || "Save current JSON & Banners to the database"}
            style={{
              background:
                saveStatus === "saved"  ? "#16a34a" :
                saveStatus === "error"  ? "#dc2626" :
                saveStatus === "saving" ? "#1e293b" :
                "#4f46e5",
              color: "#fff",
              border: "none",
              cursor: saveStatus === "saving" ? "not-allowed" : "pointer",
              display: "flex", alignItems: "center", gap: 6,
              padding: "5px 12px", borderRadius: 6, fontSize: 12, fontWeight: 600,
              transition: "background 0.2s",
              minWidth: 120,
            }}
          >
            {saveStatus === "saving" ? (
              <><FontAwesomeIcon icon={faSpinner} className="ts-spin" /> Saving…</>
            ) : saveStatus === "saved" ? (
              <><FontAwesomeIcon icon={faCheckCircle} /> Saved!</>
            ) : saveStatus === "error" ? (
              <><FontAwesomeIcon icon={faTimes} /> Save Failed</>
            ) : (
              <><FontAwesomeIcon icon={faSave} /> Save to DB</>
            )}
          </button>
          {saveError && saveStatus === "error" && (
            <span style={{ fontSize: 11, color: "#f87171", alignSelf: "center", maxWidth: 200, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              {saveError}
            </span>
          )}
          <button className="ts-btn ts-btn--ghost ts-btn--sm" onClick={handleReset}>
            <FontAwesomeIcon icon={faRefresh} /> Reset
          </button>
          <button className="ts-btn ts-btn--ghost ts-btn--sm" onClick={toggleTabSpecsModal}>
            <FontAwesomeIcon icon={faTimes} /> Close
          </button>
        </div>
      </div>

      {/* ── Split panes ── */}
      <div style={{ flex: 1, display: "flex", flexDirection: "row", overflow: "hidden", minHeight: 0 }}>

        {/* Left pane — DataGroup JSON */}
        <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden", borderRight: "1px solid #1e2533", minWidth: 0 }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "7px 14px", background: "#0c0f16", borderBottom: "1px solid #1e2533", flexShrink: 0 }}>
            <span style={{ fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em", color: "#6366f1", display: "flex", alignItems: "center", gap: 6 }}>
              <FontAwesomeIcon icon={faTable} /> DataGroup JSON
            </span>
            <span className={`ts-badge ${jsonErr ? "ts-badge--err" : "ts-badge--ok"}`}>
              {jsonErr ? "Invalid JSON" : "Valid"}
            </span>
          </div>
          <div style={{ flex: 1, overflow: "auto", background: "#080b10", minHeight: 0 }}>
            <textarea
              style={{ width: "100%", height: "100%", minHeight: "100%", background: "transparent", border: "none", outline: "none", color: "#a5f3fc", fontFamily: "'Fira Code','Cascadia Code','Consolas',monospace", fontSize: 12, lineHeight: 1.6, padding: 14, resize: "none", boxSizing: "border-box" }}
              value={jsonStr}
              onChange={e => handleJsonChange(e.target.value)}
              spellCheck={false}
            />
          </div>
          {jsonErr && (
            <div style={{ fontSize: 11, color: "#f87171", padding: "4px 14px 6px", background: "#1a0a0a", borderTop: "1px solid #3b1212", flexShrink: 0 }}>
              ⚠ {jsonErr}
            </div>
          )}
        </div>

        {/* Right pane — Banners JSON */}
        <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden", minWidth: 0 }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "7px 14px", background: "#0c0f16", borderBottom: "1px solid #1e2533", flexShrink: 0 }}>
            <span style={{ fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em", color: "#f59e0b", display: "flex", alignItems: "center", gap: 6 }}>
              <FontAwesomeIcon icon={faArrowsLeftRight} /> Banners JSON
            </span>
            <span className={`ts-badge ${bannerErr ? "ts-badge--err" : "ts-badge--ok"}`}>
              {bannerErr ? "Invalid JSON" : "Valid"}
            </span>
          </div>
          <div style={{ flex: 1, overflow: "auto", background: "#080b10", minHeight: 0 }}>
            <textarea
              style={{ width: "100%", height: "100%", minHeight: "100%", background: "transparent", border: "none", outline: "none", color: "#fde68a", fontFamily: "'Fira Code','Cascadia Code','Consolas',monospace", fontSize: 12, lineHeight: 1.6, padding: 14, resize: "none", boxSizing: "border-box" }}
              value={bannerStr}
              onChange={e => handleBannerChange(e.target.value)}
              spellCheck={false}
            />
          </div>
          {bannerErr && (
            <div style={{ fontSize: 11, color: "#f87171", padding: "4px 14px 6px", background: "#1a0a0a", borderTop: "1px solid #3b1212", flexShrink: 0 }}>
              ⚠ {bannerErr}
            </div>
          )}
        </div>
      </div>

      {/* ── Bottom chat strip ── */}
      <div style={{ display: "flex", flexDirection: "column", borderTop: "2px solid #1e2533", flexShrink: 0, background: "#0c0f16", maxHeight: "36vh" }}>
        <div style={{ padding: "7px 16px", fontSize: 11, fontWeight: 700, color: "#6366f1", textTransform: "uppercase", letterSpacing: "0.07em", display: "flex", alignItems: "center", gap: 7, borderBottom: "1px solid #1e2533", flexShrink: 0 }}>
          <FontAwesomeIcon icon={faComments} /> Real-time AI Editing
          <span style={{ marginLeft: "auto", fontSize: 10, color: "#475569", fontWeight: 400, textTransform: "none", letterSpacing: 0 }}>
            AI edits update both panes live
          </span>
        </div>

        <div className="ts-chat-body" ref={chatBodyRef} style={{ flex: 1, minHeight: 50, maxHeight: "none" }}>
          {chatMessages.length === 0 ? (
            <div className="ts-chat-empty">
              Ask the AI to make further edits — changes will reflect in the panes above instantly.<br />
              e.g. <em>"Change Q1 basetitle to All adults"</em> or <em>"Add a top 2 box net to Q3"</em>
            </div>
          ) : (
            chatMessages.map((msg, i) => (
              <div key={i} className={`ts-msg ts-msg--${msg.role}${msg.isStreaming ? " ts-msg--streaming" : ""}`}>
                {msg.text}
              </div>
            ))
          )}
        </div>

        <div className="ts-chat-input-row">
          <textarea
            ref={chatInputRef2}
            className="ts-chat-input"
            rows={1}
            placeholder="Ask AI to edit the JSON… (Enter to send, Shift+Enter for newline)"
            value={chatInput}
            onChange={e => setChatInput(e.target.value)}
            onKeyDown={e => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); handleChatSend(); } }}
            disabled={chatBusy}
          />
          <button className="ts-chat-send" onClick={handleChatSend} disabled={chatBusy || !chatInput.trim()} title="Send message">
            {chatBusy ? <FontAwesomeIcon icon={faSpinner} className="ts-spin" /> : <FontAwesomeIcon icon={faPaperPlane} />}
          </button>
        </div>
      </div>
    </div>

    </>
  );
}

export default DataTables;